import React from 'react'
import { Grid, Paper, Skeleton, Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    height: '300px',
    padding: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(4),
  },
}))

/**
 *  Wallbox skeleton component displayed on isLoading state.
 */
export const WallboxSkeleton = (): JSX.Element => {
  const { classes } = useStyles()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={6} xl={4}>
        <Paper className={classes.container}>
          <Skeleton variant="rounded" height={40} />
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={4}>
        <Paper className={classes.container}>
          <Skeleton variant="rounded" height={40} />
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={4}>
        <Paper className={classes.container}>
          <Skeleton variant="rounded" height={40} />
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={4}>
        <Paper className={classes.container}>
          <Skeleton variant="rounded" height={40} />
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={4}>
        <Paper className={classes.container}>
          <Skeleton variant="rounded" height={40} />
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={4}>
        <Paper className={classes.container}>
          <Skeleton variant="rounded" height={40} />
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
          <Stack className={classes.row}>
            <Skeleton variant="rounded" height={20} width={100} />
            <Skeleton variant="rounded" height={20} width={100} />
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  )
}
